import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-contact",
  "use": "icon-contact-usage",
  "viewBox": "0 0 12.1 12",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" viewBox=\"0 0 12.1 12\" id=\"icon-contact\">\r\n<path d=\"M10.1,0.5H2.3c-0.9,0-1.7,0.7-1.7,1.7c0,0,0,0,0,0V10c0,0.9,0.7,1.7,1.7,1.7c0,0,0,0,0,0h7.8c0.9,0,1.7-0.7,1.7-1.7l0,0V2.2\r\n\tC11.8,1.2,11,0.5,10.1,0.5C10.1,0.5,10.1,0.5,10.1,0.5z M1.9,9.6H0.6V8.9h1.3V9.6z M1.9,8.1H1.1V7.4h0.7C1.9,7.4,1.9,8.1,1.9,8.1z\r\n\t M1.9,6.6H0.6V5.9h1.3V6.6z M1.9,5.1H1.1V4.4h0.7C1.9,4.4,1.9,5.1,1.9,5.1z M1.9,3.7H0.6V2.9h1.3C1.9,2.9,1.9,3.7,1.9,3.7z M9,9.6\r\n\tc-0.9,0-2.8-1-3.7-1.9C4.4,6.9,3.4,5,3.4,4.1c0,0,0.7-1.1,1.2-1.1S6.4,4.3,6,4.8C5.5,5.2,5.1,5.2,5.1,5.7c0,0.5,0.5,0.9,0.9,1.4\r\n\tC6.4,7.5,6.9,8,7.4,8c0.5,0,0.5-0.5,0.9-0.9c0.5-0.5,1.9,0.9,1.9,1.4C10.1,8.9,9,9.6,9,9.6z\" />\r\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/contact.svg
// module id = 9a2E
// module chunks = 87